export default (context) => {
  const timestamp = Date.now()
  return context.$axios.$get(
    `${context.$config.CDN_URL}translations/lt.json?t=${timestamp}`
  )
}
